import React, { Component } from "react";
import { FormError } from "../FormError";
import { FormErrors } from "../FormErrors";
import { Link } from "react-router-dom";
import Loader from "react-loader";

import {
  FormControl,
  FormGroup,
  ControlLabel,
  HelpBlock,
  Checkbox,
  Radio,
} from "react-bootstrap";

class Corporate extends Component {
  getValidationState(isValid) {
    if (isValid === "" || isValid == null) {
      return null;
    }
    if (isValid) {
      return "success";
    } else {
      return "error";
    }
  }

  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      this.props.handleCorporateValidation(event);
    }
  };

  render() {
    return (
      <div className="container-fluid content-wrapper">
        <div className="row padTop padBottom">
          <div className="container">
            <div className="row">
              <div id="registrationCorporateUserInfo">
                <div className="join-title padBottom col-12">
                  <h1 className="title-common primary">
                    Create An Organization Account
                  </h1>
                  <p className="introText">Step 1 of 2</p>
                </div>
                <div className="col-12">
                  <form
                    onKeyPress={this.handleKeyPress}
                    id="CorporateRegistrationForm"
                  >
                    <FormErrors
                      className="genericErrorMessages"
                      formErrors={this.props.genericFormLevelProblems}
                    />
                    <FormGroup>
                      <label>ACCOUNT DETAILS</label>
                    </FormGroup>

                    {this.props.showLoader && <Loader />}
                    <FormGroup
                      controlId="formBasicTextOrgName"
                      validationState={this.getValidationState(
                        this.props.orgName.isValid
                      )}
                    >
                      <ControlLabel>
                        Organization Name{" "}
                        <strong className="text-red"> *</strong>
                      </ControlLabel>
                      <FormError
                        id="orgName-error"
                        errorMessage={this.props.orgName.message}
                      />
                      <FormControl
                        name="orgName"
                        type="text"
                        value={this.props.orgName.value}
                        onChange={this.props.handleUserInput}
                        onBlur={this.props.checkIfOrgNameValidAndAvailableEvent}
                        maxLength="50"
                        aria-required="true"
                        aria-describedby="orgName-error"
                        {...(this.props.orgName.hasErrorFocus && {
                          className: "elementFocus",
                        })}
                      />
                    </FormGroup>

                    <FormGroup
                      controlId="formBasicSelectOrgType"
                      className="orgTypeSelect"
                      validationState={this.getValidationState(
                        this.props.questionAndAnswerOrganizationTypeSelected
                          .isValid
                      )}
                    >
                      <ControlLabel>
                        {this.props.questionAndAnswerOrganizationTypeLabel}{" "}
                        <strong className="text-red"> *</strong>
                      </ControlLabel>
                      <FormError
                        id="questionAndAnswerOrganizationTypeSelected-error"
                        errorMessage={
                          this.props.questionAndAnswerOrganizationTypeSelected
                            .message
                        }
                      />
                      <FormControl
                        componentClass="select"
                        name="questionAndAnswerOrganizationTypeSelected"
                        onChange={this.props.handleUserInput}
                        aria-required="true"
                        aria-describedby="questionAndAnswerOrganizationTypeSelected-error"
                        {...(this.props
                          .questionAndAnswerOrganizationTypeSelected
                          .hasErrorFocus && { className: "elementFocus" })}
                      >
                        <option value="">Select Organization Type</option>
                        {this.props.questionAndAnswerOrganizationTypes.map(
                          (possibleOption, index) => {
                            return (
                              <option
                                key={index}
                                name="questionAndAnswerOrgTypeSelectedOption"
                                value={possibleOption}
                                selected={
                                  this.props.questionAndAnswerOrganizationTypeSelected.indexOf(
                                    possibleOption
                                  ) > -1
                                }
                              >
                                {possibleOption}
                              </option>
                            );
                          }
                        )}
                      </FormControl>
                    </FormGroup>

                    <FormGroup
                      controlId="formBasicTextAdminFirstName"
                      validationState={this.getValidationState(
                        this.props.firstName.isValid
                      )}
                    >
                      <ControlLabel>
                        Account Admin First Name{" "}
                        <strong className="text-red"> *</strong>
                      </ControlLabel>
                      <FormError
                        id="firstName-error"
                        errorMessage={this.props.firstName.message}
                      />
                      <FormControl
                        name="firstName"
                        type="text"
                        value={this.props.firstName.value}
                        onChange={this.props.handleUserInput}
                        maxLength="30"
                        aria-required="true"
                        aria-describedby="firstName-error"
                        {...(this.props.firstName.hasErrorFocus && {
                          className: "elementFocus",
                        })}
                      />
                    </FormGroup>

                    <FormGroup
                      controlId="formBasicTextAdminLastName"
                      validationState={this.getValidationState(
                        this.props.lastName.isValid
                      )}
                    >
                      <ControlLabel>
                        Account Admin Last Name{" "}
                        <strong className="text-red"> *</strong>
                      </ControlLabel>
                      <FormError
                        id="lastName-error"
                        errorMessage={this.props.lastName.message}
                      />
                      <FormControl
                        name="lastName"
                        type="text"
                        value={this.props.lastName.value}
                        onChange={this.props.handleUserInput}
                        maxLength="30"
                        aria-required="true"
                        aria-describedby="lastName-error"
                        {...(this.props.lastName.hasErrorFocus && {
                          className: "elementFocus",
                        })}
                      />
                    </FormGroup>

                    <FormGroup
                      controlId="formBasicTextAdminEmail"
                      validationState={this.getValidationState(
                        this.props.email.isValid
                      )}
                    >
                      <ControlLabel>
                        Email <strong className="text-red"> *</strong>
                      </ControlLabel>
                      <FormError
                        id="email-error"
                        hasHtml="true"
                        errorMessage={this.props.email.message}
                      />
                      <FormControl
                        name="email"
                        type="text"
                        value={this.props.email.value}
                        onChange={this.props.handleUserInput}
                        maxLength="45"
                        aria-required="true"
                        aria-describedby="email-error"
                        {...(this.props.email.hasErrorFocus && {
                          className: "elementFocus",
                        })}
                      />
                    </FormGroup>

                    <FormGroup
                      controlId="formBasicTextAdminPassword"
                      validationState={this.getValidationState(
                        this.props.password.isValid
                      )}
                    >
                      <ControlLabel>
                        Password <strong className="text-red"> *</strong>
                      </ControlLabel>
                      <FormError
                        id="password-error"
                        errorMessage={this.props.password.message}
                      />
                      <FormControl
                        name="password"
                        type="password"
                        value={this.props.password.value}
                        onChange={this.props.handleUserInput}
                        maxLength="24"
                        aria-required="true"
                        aria-describedby="password-error"
                        {...(this.props.password.hasErrorFocus && {
                          className: "elementFocus",
                        })}
                      />
                      <HelpBlock>8 Characters Minimum</HelpBlock>
                      <HelpBlock>One lower case</HelpBlock>
                      <HelpBlock>One upper case</HelpBlock>
                      <HelpBlock>One special character</HelpBlock>
                      <HelpBlock>One numeric</HelpBlock>
                      <HelpBlock>
                        Must not have 3 or more sequential/ascending/descending
                        characters
                      </HelpBlock>
                    </FormGroup>

                    <FormGroup
                      controlId="formQuestionAndAnswerFirstContributions"
                      className="fn-devProgram"
                    >
                      <ControlLabel>
                        {this.props.questionAndAnswerContributionsQuestion}
                      </ControlLabel>
                      <br />
                      {this.props.questionAndAnswerContributionsPossibleOptions.map(
                        (possibleOption, index) => {
                          return (
                            <Checkbox
                              key={index}
                              name="questionAndAnswerContributionsSelectedOptions"
                              value={possibleOption}
                              onChange={this.props.handleUserInput}
                              checked={
                                this.props.questionAndAnswerContributionsSelectedOptions.indexOf(
                                  possibleOption
                                ) > -1
                              }
                            >
                              {possibleOption}
                            </Checkbox>
                          );
                        }
                      )}
                    </FormGroup>

                    <FormGroup
                      controlId="formQuestionAndAnswerFirstResponder"
                      className="fn-responder"
                    >
                      <ControlLabel>
                        {this.props.questionAndAnswerFirstResponderQuestion}
                      </ControlLabel>
                      <br />

                      {this.props.questionAndAnswerFirstResponderPossibleAnswers.map(
                        (possibleOption, index) => {
                          return (
                            <Radio
                              key={index}
                              checked={
                                this.props.questionAndAnswerFirstResponderAnswers.indexOf(
                                  possibleOption
                                ) > -1
                              }
                              name="questionAndAnswerFirstResponderAnswers"
                              value={possibleOption}
                              onChange={this.props.handleUserInput}
                            >
                              {possibleOption}
                            </Radio>
                          );
                        }
                      )}
                    </FormGroup>

                    <br />
                    <strong>SUBSCRIPTION PREFERENCES </strong>

                    <FormGroup controlId="newsletterSubscriptionPreferences">
                      <br />
                      <Checkbox
                        inline
                        checked={this.props.newsletterSubscription.value}
                        name="newsletterSubscription"
                        value="newsletterSubscription"
                        onChange={this.props.handleUserInput}
                      >
                        Send me the latest news and exclusive offers from the
                        FirstNet Developer Program (monthly newsletter, API
                        information and updates, program updates, and alerts)
                      </Checkbox>
                    </FormGroup>

                    <FormGroup controlId="eventsSubscriptionPreferences">
                      <br />
                      <Checkbox
                        inline
                        checked={this.props.eventsSubscription.value}
                        name="eventsSubscription"
                        value="eventsSubscription"
                        onChange={this.props.handleUserInput}
                      >
                        Event notifications for upcoming FirstNet Developer
                        Program, Hackathons, and events such as Developer
                        Summit, DevLab, and other sponsored events
                      </Checkbox>
                    </FormGroup>
                    <Link
                      to="/corporateTos"
                      className="button primary light-bg variableWidth next"
                      role="button"
                      onClick={this.props.handleCorporateValidation}
                    >
                      Continue
                    </Link>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Corporate;



// WEBPACK FOOTER //
// ./src/registration/Corporate.js